import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const TIME_OPTIONS = [
  '9am', '10am', '11am', '12pm',
  '1pm', '2pm', '3pm', '4pm',
  '5pm', '6pm', '7pm', '8pm', '9pm',
];

const CouplesDatePlan = ({ data, onNext }) => {
  const [form, setForm] = useState({
    includeDatePlan: data.includeDatePlan || false,
    eventDate: data.eventDate || '',
    eventTime: data.eventTime || '',
    eventLocation: data.eventLocation || '',
  });

  const today = new Date().toISOString().split('T')[0];

  const handleSubmit = () => {
    onNext(form);
  };

  return (
    <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-1">Plan a Date? 📅</h2>
      <p className="text-gray-500 text-sm mb-6">Optional — add a date, time, and location</p>

      <div className="space-y-5">
        {/* Toggle */}
        <button
          onClick={() => setForm({ ...form, includeDatePlan: !form.includeDatePlan })}
          className={`w-full p-4 rounded-xl border-2 transition-all flex items-center gap-3 ${
            form.includeDatePlan ? 'border-purple-500 bg-purple-50' : 'border-gray-200 bg-white'
          }`}
        >
          <div className={`w-12 h-7 rounded-full transition-all flex items-center ${
            form.includeDatePlan ? 'bg-purple-500 justify-end' : 'bg-gray-300 justify-start'
          }`}>
            <div className="w-5 h-5 bg-white rounded-full mx-1 shadow" />
          </div>
          <div className="text-left">
            <p className="font-semibold text-gray-800 text-sm">Include Date Plan</p>
            <p className="text-xs text-gray-400">Add date, time & location details</p>
          </div>
        </button>

        {form.includeDatePlan && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            className="space-y-4"
          >
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                <SafeIcon name="Calendar" className="inline mr-1 text-purple-500" /> Date
              </label>
              <input type="date" min={today} value={form.eventDate}
                onChange={(e) => setForm({ ...form, eventDate: e.target.value })}
                className="w-full p-4 rounded-xl border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-100 outline-none" />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <SafeIcon name="Clock" className="inline mr-1 text-purple-500" /> Time
              </label>
              <div className="grid grid-cols-4 gap-2">
                {TIME_OPTIONS.map((t) => (
                  <button
                    key={t}
                    type="button"
                    onClick={() => setForm({ ...form, eventTime: t })}
                    className={`py-2.5 rounded-lg text-sm font-medium transition-all ${
                      form.eventTime === t
                        ? 'bg-purple-500 text-white shadow-md'
                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                    }`}
                  >
                    {t}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                <SafeIcon name="MapPin" className="inline mr-1 text-purple-500" /> Location
                <span className="text-gray-400 font-normal ml-1">(optional)</span>
              </label>
              <input type="text" value={form.eventLocation}
                onChange={(e) => setForm({ ...form, eventLocation: e.target.value })}
                placeholder="e.g. The Italian Place on Main St"
                className="w-full p-4 rounded-xl border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-100 outline-none" />
            </div>
          </motion.div>
        )}

        <button onClick={handleSubmit}
          className="w-full bg-gradient-to-r from-purple-500 to-violet-500 text-white font-bold py-4 rounded-xl shadow-lg shadow-purple-200">
          Continue to Preview →
        </button>
      </div>
    </motion.div>
  );
};

export default CouplesDatePlan;